<script>
  // @ts-check
  import { fade, slide } from "svelte/transition";
  import { cubicInOut } from "svelte/easing";

  import GridContainer from "../atoms/GridContainer.svelte";
  import Search from "../molecules/Search/Search.svelte";
  import SearchResultList from "../molecules/SearchResultList/SearchResultList.svelte";
  import { getTheme } from "../utilities";

  /** @typedef {import("svelte").ComponentProps<Search>} SearchProps */
  /** @typedef {import("svelte").ComponentProps<SearchResultList>} SearchResultListProps */

  /** Primarily used for testing
   * @type {string} */
  export let id = undefined;

  /** @type { SearchProps["searchId"] } */
  export let searchId = null;

  /** @type { SearchProps["autocomplete"] } */
  export let autocomplete = null;

  /** @type { SearchProps["isLoading"] } */
  export let isLoading = false;

  /** @type { SearchProps["selectedValue"] } */
  export let selectedValue = null;

  /** @type { SearchProps["focusOnMount"] } */
  export let focusOnMount = false;

  /** @type { SearchProps["errorMessage"] } */
  export let errorMessage = null;

  /** @type { SearchProps["searchQuerySuggestionsProps"] } */
  export let searchQuerySuggestionsProps = null;

  /** @type { SearchProps["loadingAccessibilityLabel"] } */
  export let loadingAccessibilityLabel = null;

  /** @type { SearchResultListProps["links"] } */
  export let results = [];

  /** @type { SearchResultListProps["title"] } */
  export let resultsTitle = "";

  /**
   * The theme of the search panel
   * @type {import('../utilities/themes.js').ThemeName}
   */
  export let theme = "white";
  let currentTheme = getTheme(theme);

  /** @type { string } */
  let componentClass = "";
  export { componentClass as class };
</script>

<div
  {id}
  class="{currentTheme.backgroundColor} max-h-dvh overflow-y-auto pb-7.5 pt-7.5 lg:min-h-[250px] lg:pb-15 xl:min-h-[270px] {componentClass}"
>
  <GridContainer>
    <Search
      on:submit
      on:clear
      on:change
      on:input
      on:querySuggestionItemSelect
      {focusOnMount}
      {searchId}
      {autocomplete}
      {isLoading}
      {errorMessage}
      {selectedValue}
      {searchQuerySuggestionsProps}
      {loadingAccessibilityLabel}
    />
    {#if results?.length > 0 && !errorMessage}
      <div
        class="h-full w-full"
        transition:slide={{ duration: 300, delay: 300, easing: cubicInOut }}
      >
        <div transition:fade={{ duration: 600, delay: 300, easing: cubicInOut }}>
          <SearchResultList
            componentClass="mt-10 lg:mt-15"
            {theme}
            layoutVariant="small"
            links={results}
            title={resultsTitle}
          >
            <slot name="button" slot="button" />
          </SearchResultList>
        </div>
      </div>
    {/if}
  </GridContainer>
</div>
